import { instance } from 'store/utils';
import { types } from './types';
import { downloadFile, downloadRequestHeaders } from 'store/forms/utils';
import { message } from 'antd';
import { triggerLoading } from 'store/forms/actions';
import { Errors } from 'utils/errors';

export const react_path = process.env.REACT_APP_PROCESS_APP;

export const getFormData = taskId => dispatch => {
  dispatch({ type: types.GET_FORM_DATA_APP.START });
  instance
    .get(`/app/rest/task-forms/${taskId}/with-vars`)
    .then(response => {
      dispatch({
        type: types.GET_FORM_DATA_APP.SUCCESS,
        payload: response.data,
      });
    })
    .catch(error => {
      console.log(error, 'error');
      dispatch({ type: types.GET_FORM_DATA_APP.ERROR });
    });
};

export const fetchProcessSAYT = searchKey => dispatch => {
  dispatch({ type: types.FETCH_PROCESS_SAYT.START });
  instance
    .get(`/app/rest/findSAYT?searchKey=` + searchKey)
    .then(response => {
      dispatch({
        type: types.FETCH_PROCESS_SAYT.SUCCESS,
        payload: response.data,
      });
    })
    .catch(error => {
      console.log(error, 'error');
      dispatch({ type: types.FETCH_PROCESS_SAYT.ERROR });
    });
};

export const getActions = procInstId => dispatch => {
  dispatch({ type: types.GET_ACTIONS.START });
  instance
    .get(`/app/rest/${procInstId}/actions`)
    .then(response => {
      dispatch({ type: types.GET_ACTIONS.SUCCESS, payload: response.data });
    })
    .catch(error => {
      console.log(error, 'error');
      dispatch({ type: types.GET_ACTIONS.ERROR });
    });
};

export const getTaskData = taskId => dispatch => {
  dispatch({ type: types.GET_TASK_DATA.START });
  instance
    .get(`/app/rest/tasks/${taskId}`)
    .then(response => {
      dispatch({ type: types.GET_TASK_DATA.SUCCESS, payload: response.data });
    })
    .catch(error => {
      console.log(error, 'error');
      dispatch({ type: types.GET_TASK_DATA.ERROR });
    });
};

export const fetchProcInstancesDetailed = data => dispatch => {
  dispatch({ type: types.GET_PROCESS_INSTANCES_APP.START });
  instance
    .post(`/app/rest/process-instances-apptrack`, data)
    .then(response => {
      const res = response.data.data;
      const results = Object.keys(res).map(key => ({
        id: key,
        ...res[key],
      }));
      dispatch({
        type: types.GET_PROCESS_INSTANCES_APP.SUCCESS,
        payload: {
          variables: results,
        },
      });
      // if(!params.isViewMode){
      // dispatch(getFormData(params.taskId));
      // }
    })
    .catch(error => {
      console.log(error, 'error');
      dispatch({ type: types.GET_PROCESS_INSTANCES_APP.ERROR });
    });
};

export const fetchProcInstancesFundingPaginated =
  (detailedPayload, page, pageSize) => dispatch => {
    let payload = {
      parameterList: detailedPayload?.parameterList ?? [],
      page,
      pageSize,
    };
    dispatch({ type: types.GET_PROCESS_INSTANCES_APP.START });
    instance
      .post(`/onboarding/funding-admin/interest-application/search`, payload)
      .then(response => {
        const res = response.data.data;
        const resultSize = response?.data?.size;
        const results = Object.entries(res).map(([key, value]) => ({
          id: key,
          ...value,
        }));

        results.sort((a, b) => Number(a.businessKey) - Number(b.businessKey));

        dispatch({
          type: types.GET_PROCESS_INSTANCES_APP.SUCCESS,
          payload: {
            variables: results,
            resultSize: resultSize,
          },
        });
      })
      .catch(error => {
        console.log(error, 'error');
        dispatch({ type: types.GET_PROCESS_INSTANCES_APP.ERROR });
      });
  };

export const clearApptrack = () => dispatch => {
  dispatch({ type: types.CLEAR_APPTRACK.SUCCESS });
};

export const clearSayt = () => dispatch => {
  dispatch({ type: types.CLEAR_SAYT });
};

export const navigateToView = (navigate, processInstanceId) => {
  navigate(`/apptrack/${processInstanceId}`);
};

export const cancelProcessInstance = procInstId => dispatch => {
  dispatch({ type: types.CANCEL_PROCESS.START });
  instance
    .get(`/app/rest/cancel-process-instance/${procInstId}`)
    .then(response => {
      dispatch({ type: types.CANCEL_PROCESS.SUCCESS, payload: response.data });
    })
    .catch(error => {
      dispatch({ type: types.CANCEL_PROCESS.ERROR, error });
    });
};

export const getDetails = processInstanceId => {
  return instance
    .get(`/app/rest/process-instance-apptrack-detailed/${processInstanceId}`)
    .then(response => {
      return response.data.variablesIndexed;
    });
};

export const getApptrackDetails = processInstanceId => dispatch => {
  dispatch({ type: types.GET_APPTRACK_DETAILS.START });

  instance
    .get(`/app/rest/process-instance-apptrack-detailed/${processInstanceId}`)
    .then(response => {
      // console.log("RESPONSE",response.data);
      dispatch({
        type: types.GET_APPTRACK_DETAILS.SUCCESS,
        payload: {
          activeTaskName: response.data.activeTaskName,
          businessKey: response.data.businessKey,
          localTaskVariables: response.data.localTaskVariables,
          variablesIndexed: response.data.variablesIndexed,
          contentItems: response.data.contentItems,
          comments: response.data.comments,
        },
      });
    })
    .catch(error => {
      dispatch({ type: types.GET_APPTRACK_DETAILS.ERROR });

      console.log(error, 'error');
    });
};

export const getOffersHistory = () => dispatch => {
  dispatch({ type: types.GET_OFFERS_HISTORY.START });

  instance
    .get(`/app/rest/offers/uploads`)
    .then(response => {
      dispatch({
        type: types.GET_OFFERS_HISTORY.SUCCESS,
        payload: response.data,
      });
    })
    .catch(error => {
      dispatch({ type: types.GET_OFFERS_HISTORY.ERROR });

      console.log(error, 'error');
    });
};

export const uploadOffers =
  ({ file, callback }) =>
  dispatch => {
    dispatch({ type: types.UPLOAD_OFFERS.START });

    instance
      .post(`/app/rest/offers/upload`, file)
      .then(response => {
        console.log(response.data);
        dispatch({
          type: types.UPLOAD_OFFERS.SUCCESS,
        });
        callback(true);
      })
      .catch(error => {
        dispatch({ type: types.UPLOAD_OFFERS.ERROR });
        callback(false);
        console.log(error, 'error');
      });
  };

export const downloadUploadedFilev2 = fileInfo => dispatch => {
  message.loading('Αναμονή λήψης αρχείου');
  dispatch({ type: types.DOWNLOAD_UPLOADED_FILE.START });
  instance
    .get(`/app/rest/downloadFile?fileId=${fileInfo?.id}`, {
      responseType: 'blob',
    })
    .then(response => {
      //create hidden anchor and click behind the scenes to trigger download
      const link = document.createElement('a');
      link.href = URL.createObjectURL(response.data);
      link.download = fileInfo?.filename;
      link.click();
      dispatch({
        type: types.DOWNLOAD_UPLOADED_FILE.SUCCESS,
      });
    })
    .catch(error => {
      console.log(error, 'error');
      dispatch({ type: types.DOWNLOAD_UPLOADED_FILE.ERROR });
      // message.error("Σφάλμα κατά τη λήψη του αρχείου");
    });
};

export const getActiveOffers =
  (infrprov = '') =>
  dispatch => {
    dispatch({ type: types.GET_ACTIVE_OFFERS.START });

    instance
      .get(`/app/rest/offers/getAll${infrprov ? `/${infrprov}` : ''}`)
      .then(response => {
        dispatch({
          type: types.GET_ACTIVE_OFFERS.SUCCESS,
          payload: response.data,
        });
      })
      .catch(error => {
        dispatch({ type: types.GET_ACTIVE_OFFERS.ERROR });

        console.log(error, 'error');
      });
  };

export const clearActiveOffers = () => dispatch => {
  dispatch({ type: types.CLEAR_ACTIVE_OFFERS.SUCCESS, payload: {} });
};

export const openUploadOffersModal = open => dispatch => {
  dispatch({ type: types.OPEN_UPLOAD_OFFERS_MODAL.SUCCESS, payload: open });
};
export const openUploadProviderModal = open => dispatch => {
  dispatch({ type: types.OPEN_UPLOAD_PROVIDER_MODAL.SUCCESS, payload: open });
};
export const setSelectedOffersFileFlag = selected => dispatch => {
  dispatch({ type: types.SET_SELECTED_OFFERS_FILE.SUCCESS, payload: selected });
};
export const setSelectedProviderFileFlag = selected => dispatch => {
  dispatch({
    type: types.SET_SELECTED_PROVIDER_FILE.SUCCESS,
    payload: selected,
  });
};

export const setApptrackLoading = () => dispatch => {
  dispatch({ type: types.SET_APPTRACK_LOADING });
};

export const getAllTaskNames = () => dispatch => {
  dispatch({ type: types.GET_ALL_TASK_NAMES.START });

  instance
    .get(`/app/rest/all-task-names`)
    .then(response => {
      dispatch({
        type: types.GET_ALL_TASK_NAMES.SUCCESS,
        payload: response.data,
      });
    })
    .catch(error => {
      dispatch({ type: types.GET_ALL_TASK_NAMES.ERROR });

      console.log(error, 'error');
    });
};

export const addComment = (id, data) => dispatch => {
  const payload = {
    id: '',
    message: data,
    created: '',
    createdBy: '',
  };

  return instance
    .post(`/app/rest/process-instances/${id}/comments`, payload)
    .then(response => {
      // dispatch({
      //   type: types.GET_ALL_TASK_NAMES.SUCCESS,
      //   payload: response.data,
      // });
    })
    .catch(error => {
      // dispatch({ type: types.GET_ALL_TASK_NAMES.ERROR });
      console.log(error, 'error');
    });
};

export const uploadReserveRedeeem =
  ({ file, callback }) =>
  dispatch => {
    dispatch({ type: types.UPLOAD_PROVIDER.START });
    instance
      .put(`/app/rest/providers/mass-reserve`, file)
      .then(response => {
        dispatch({
          type: types.UPLOAD_PROVIDER.SUCCESS,
        });
        callback(true);
      })
      .catch(error => {
        dispatch({ type: types.UPLOAD_PROVIDER.ERROR });
        callback(false);
        console.log(error, 'error');
      });
  };

export const getProviderHistory = () => dispatch => {
  dispatch({ type: types.GET_PROVIDER_HISTORY.START });

  instance
    .get(`/app/rest/providers/uploads`)
    .then(response => {
      dispatch({
        type: types.GET_PROVIDER_HISTORY.SUCCESS,
        payload: response.data,
      });
    })
    .catch(error => {
      dispatch({ type: types.GET_PROVIDER_HISTORY.ERROR });
      console.log(error, 'error');
    });
};

export const getProviderHistoryExcelDetail = (fileInfo, params) => dispatch => {
  message.loading('Αναμονή λήψης αρχείου');
  const status = params;
  dispatch({ type: types.GET_PROVIDER_HISTORY_DETAILS.START });
  instance
    .post(
      `/app/rest/providers/details?fieldId=${fileInfo?.id}`,
      { status },
      { responseType: 'blob' }
    )
    .then(response => {
      //create hidden anchor and click behind the scenes to trigger download
      const link = document.createElement('a');
      link.href = URL.createObjectURL(response.data);
      link.download = fileInfo?.filename;
      link.click();
      dispatch({
        type: types.GET_PROVIDER_HISTORY_DETAILS.SUCCESS,
      });
    })
    .catch(error => {
      console.log(error, 'error');
      dispatch({ type: types.GET_PROVIDER_HISTORY_DETAILS.ERROR });
      // message.error("Σφάλμα κατά τη λήψη του αρχείου");
    });
};

export const navigateToViewOnly = (navigate, processInstanceId) => {
  navigate(`/apptrack/disabled/${processInstanceId}`);
};

export const clearApptrackDetails = () => dispatch => {
  dispatch({ type: types.CLEAR_APPTRACK_DETAILS.SUCCESS });
};

export const fetchRecords = (detailedPayload, page, pageSize) => dispatch => {
  dispatch({ type: types.GET_PROCESS_INSTANCES_APP.START });
  let payload = {
    parameterList: detailedPayload?.parameterList ?? [],
    page,
    pageSize,
  };
  instance
    .post(`/app/rest/process-instances-paginated`, payload)
    .then(response => {
      const res = response.data.data;
      const resultSize = response?.data?.size;
      const results = Object.keys(res).map(key => ({
        id: key,
        ...res[key],
      }));
      dispatch({
        type: types.GET_PROCESS_INSTANCES_APP.SUCCESS,
        payload: {
          variables: results,
          resultSize: resultSize,
        },
      });
      // if(!params.isViewMode){
      // dispatch(getFormData(params.taskId));
      // }
    })
    .catch(error => {
      console.log(error, 'error');
      dispatch({ type: types.GET_PROCESS_INSTANCES_APP.ERROR });
    });
};

export const updateFile = (id, payload) => dispatch => {
  dispatch({ type: types.UPDATE_FILE.START });
  return instance
    .post(`/app/rest/tasks/${id}/raw-contents`, payload)
    .then(response => {
      dispatch({
        type: types.UPDATE_FILE.SUCCESS,
        payload: response.data,
      });
      return { success: true, data: response.data };
    })
    .catch(error => {
      dispatch({ type: types.UPDATE_FILE.ERROR });
      dispatch(triggerLoading(false));
      return { success: false, error };
    });
};

export const updateEligibility = (id, payload, navigate) => dispatch => {
  dispatch({ type: types.UPDATE_GENERATE.START });
  return instance
    .post(`/app/rest/update-eligibility-excel/${id}`, payload)
    .then(response => {
      dispatch(triggerLoading(false));
      dispatch({
        type: types.UPDATE_GENERATE.SUCCESS,
        payload: response.data,
      });
      localStorage.setItem('showUpdateModal', true);
      navigate('/appTrack');
      return { success: response.data.success, data: response.data };
    })
    .catch(error => {
      dispatch(triggerLoading(false));
      dispatch({ type: types.UPDATE_GENERATE.ERROR });
      console.log(error, 'error');
      return { success: false, error };
    });
};

export const updateFinancial = (id, payload, navigate) => dispatch => {
  dispatch({ type: types.UPDATE_GENERATE.START });
  return instance
    .post(`/app/rest/update-financial-model/${id}`, payload)
    .then(response => {
      dispatch(triggerLoading(false));
      dispatch({
        type: types.UPDATE_GENERATE.SUCCESS,
        payload: response.data,
      });
      localStorage.setItem('showUpdateModal', true);
      navigate('/appTrack');
      return { success: true, data: response.data };
    })
    .catch(error => {
      dispatch({ type: types.UPDATE_GENERATE.ERROR });
      console.log(error, 'error');
      dispatch(triggerLoading(false));
      return { success: false, error };
    });
};

export const fetchById = (navigate, id) => dispatch => {
  dispatch({ type: types.FETCH_VIEWFORM_BY_ID.START });
  dispatch(triggerLoading(false));
  return instance
    .get(`/accounts/me/funding-applications/${id}`)
    .then(response => {
      dispatch({
        type: types.FETCH_VIEWFORM_BY_ID.SUCCESS,
        payload: response.data,
      });
      navigate(`/viewForm/${id}`);
    })
    .catch(error => {
      dispatch({ type: types.FETCH_VIEWFORM_BY_ID.ERROR, error });
      message.error(Errors.GenericError);
      throw error;
    })
    .finally(() => {
      dispatch(triggerLoading(false));
    });
};

export const fetchFundingApplications =
  (detailedPayload, page, pageSize) => dispatch => {
    let payload = {
      page,
      pageSize,
    };

    dispatch({ type: types.GET_PROCESS_INSTANCES_APP.START });

    instance
      .post(`/accounts/me/funding-applications/search`, payload)
      .then(response => {
        const res = response.data.data;
        const resultSize = response?.data?.size;

        // Transform the data to match table structure
        const results = Object.values(res ?? {}).map((value, index) => {
          // Debug log for one item

          const transformed = {
            id: value.applicationId,
            aa: (page - 1) * pageSize + index + 1,
            afm: value.taxId,
            name: value.companyName,
            investmentPlace: value.location,
            activeTaskId: value.activeTaskId,
            businessKey: value.businessKey,
            applicationId: value.applicationId,
            programs: (value.fundingPrograms ?? []).map(program => ({
              title: program.title,
              fundingAmount: program.fundingAmount,
            })),
            fundingScheme: {
              totalBudget: value.fundingScheme?.total?.amount
                ? `€${parseFloat(
                    value.fundingScheme.total.amount
                  ).toLocaleString('el-GR', { minimumFractionDigits: 2 })}`
                : '-',
              grant: value.fundingScheme?.subsidy?.amount
                ? `€${parseFloat(
                    value.fundingScheme.subsidy.amount
                  ).toLocaleString('el-GR', { minimumFractionDigits: 2 })}`
                : '-',
              ownParticipation: value.fundingScheme?.participation?.amount
                ? `€${parseFloat(
                    value.fundingScheme.participation.amount
                  ).toLocaleString('el-GR', { minimumFractionDigits: 2 })}`
                : '-',
              bankLoan: value.fundingScheme?.loan?.amount
                ? `€${parseFloat(
                    value.fundingScheme.loan.amount
                  ).toLocaleString('el-GR', { minimumFractionDigits: 2 })}`
                : '-',
            },

            applicationDate: value.createdOn
              ? new Date(value.createdOn).toLocaleDateString('el-GR')
              : '-',
            submissionDate: value.submittedOn
              ? new Date(value.submittedOn).toLocaleDateString('el-GR')
              : '-',
          };
          return transformed;
        });

        dispatch({
          type: types.GET_PROCESS_INSTANCES_APP.SUCCESS,
          payload: {
            variables: results,
            resultSize: resultSize,
          },
        });
      })
      .catch(error => {
        console.log(error, 'error');
        dispatch({ type: types.GET_PROCESS_INSTANCES_APP.ERROR });
      });
  };
